const VERSION = 5;
export const CHAIN = 'eth';
// export const STATISTICS_API = 'http://localhost:3004';
export const STATISTICS_API = 'https://devjs-01.corp.aira.life:3004';
export const FACTORY = {
  name: 'factory.' + VERSION + '.robonomics.eth',
  address: '0x7e384AD1FE06747594a6102EE5b377b273DC1225'
};
export const XRT = {
  name: 'xrt.' + VERSION + '.robonomics.eth',
  address: '0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7'
};
export const NET_TOPICS = [
  'graph.' + VERSION + '.robonomics.eth',
  'graph.' + VERSION + '.robonomics.sid'
];
export const ENS = '0x314159265dD8dbb310642f98f50C066173C1259b';
